import axios, { AxiosResponse } from 'axios';
import { useQuery } from '@tanstack/react-query';

type Props = {
  url: string;
  queryOptions?: Partial<Parameters<typeof useQuery>[0]>;
};

const useItemQuery = ({ url, queryOptions = {} }: Props) =>
  useQuery({
    queryKey: ['productItem', url],
    queryFn: async () => await axios.get(url),
    enabled: !!url,
    select: (data: AxiosResponse) => data.data?.jsonItem || data.data,
    refetchOnWindowFocus: false,
    staleTime: 1000 * 60 * 5, // 5 minutes
    ...queryOptions,
  });

export default useItemQuery;
